<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

  <ng-container *ngIf="consulta">

    <ul class="card-list-striped">
      <li><span class="text-secondary">Evento </span> <span>{{consulta?.evento || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Tipo documento </span>
        <span>{{consulta?.tipoDocumento || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Data evento </span> <span>{{consulta?.dataEvento || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Observação </span> <span>{{consulta?.observacao || "NÃO INFORMADO"}}</span>
      </li>
    </ul>

  </ng-container>

</app-card-consulta>
